import styled from 'styled-components';

export const StyledContent = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
`;

export const StyledSubtitle = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 40px;
  @media screen and (max-width: 600px) {
    font-size: 20px;
  }
`;

export const StyledCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const StyledLoginContainer = styled.div`
  @media screen and (max-width: 900px) {
    form {
      padding: 0 30px;
    }
  }
`;

export const NotifContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
  width: 360px;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  color: #333;
  font-size: 14px;
`;

export const NotifContent = styled.div`
  position: relative;
`;

export const NotifCloseButton = styled.button`
  position: absolute;
  top: -6px;
  right: 8px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #888;

  &:hover {
    color: #000;
  }
`;

export const NotifTitle = styled.h4`
  margin: 0 0 8px 0;
`;

export const NotifParagraph = styled.p`
  margin: 0 0 8px 0;
`;

export const NotifStepList = styled.ul`
  padding-left: 16px;
  margin: 8px 0;

  li {
    margin-bottom: 8px;
  }
`;
